<div
	class="fab-container"
	[class.open]="isOpen">
	<button
		mat-fab
		type="button"
		color="primary"
		class="fab-toggler"
		aria-label="Toggle protocol actions"
		(click)="onToggleFab()">
		<mat-icon>menu</mat-icon>
	</button>
	<div class="fab-actions">
		@for (btn of fabButtons; track btn.label; let i = $index) {
			<button
				mat-raised-button
				type="button"
				class="fab-action-button"
				color="primary"
				[matTooltip]="btn.tooltip"
				[style.transition-delay.ms]="i * 40"
				[attr.aria-label]="btn.tooltip"
				(click)="callItemFn(btn.label)">
				<mat-icon>{{ btn.icon }}</mat-icon>
				<span class="fab-action-label">{{ btn.tooltip }}</span>
			</button>
		}
	</div>
</div>
